//Authentication
export const RESET_PASSWORD = "/reset-password"
export const UPDATE_PASSWORD = "/auth/changePassword"
export const RESET_AGENCY_PASSWORD = "/reset-agency-user-password"
export const FORGOT_PASSWORD = "/forgot-Password"

// Banners
export const CREATE_BANNER = "/banner"
export const GET_BANNERS = "/banner"
export const GET_SINGLE_BANNER = "/banner"
export const UPDATE_BANNERS = "/banner"

// Products
export const GET_ALL_PRODUCTS = "/product"

// Users
export const GET_ALL_USERS = "/user/all"
export const UPDATE_USER = "/user";
export const ADD_USER = "/user";

// Dashboard
export const GET_DASHBOARD_DATA = "/dashboard"

//FAQS
export const GET_FAQS = "/genericData";

// THREADS
export const GET_THREADS = "/threads";
export const GET_USERS = "/chatUser";

// COMPANIES / CLIENTS
export const GET_COMPANIES = "/companies";
